import { configureStore } from "@reduxjs/toolkit";
import platformOptionsReducer from "../store/slices/platformOptions";
import userReducer from "../store/slices/userSlice"; // 👈 Import your user slice

export const store = configureStore({
  reducer: {
    platformOptions: platformOptionsReducer,
    user: userReducer, // 👈 Add the user reducer here
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
